import { switchMap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { AuthService } from '../../../services/common/auth.service';
import { Vendor } from '../../../models/vendor';
import { VendorService } from '../../../services/accounting/vendor.service';

@Component({
  selector: 'app-vendor-edit',
  templateUrl: './vendor-edit.component.html',
  styleUrls: ['./vendor-edit.component.css'],
})
export class VendorEditComponent implements OnInit {
  vendor: Vendor;

  vendorLoading: boolean = true;

  constructor(private router: Router, private authService: AuthService, private route: ActivatedRoute, private vendorService: VendorService) {
    this.authService.fetchUserGroups().then((response_json) => {
      let groups = response_json.groups;
      if (groups.indexOf('personnel') > -1 || groups.indexOf('admin') > -1 || groups.indexOf('management') > -1 || groups.indexOf('owner') > -1)
        this.route.params.pipe(switchMap((params: Params) => this.vendorService.getVendorEdit(params['id']))).subscribe((response_json) => {
          this.vendor = response_json.vendor;
          this.vendorLoading = false;
        });
      else this.router.navigate(['/']);
    });
  }

  ngOnInit() {}
}
